import { FaLinkedin, FaLocationDot } from "react-icons/fa6";
import Logo from "../navbar/Logo";
import { FaPhone } from "react-icons/fa";
import Link from "next/link";
import { useEffect, useState } from "react";
import {
  FaFacebook,
  FaInstagram,
  FaYoutube,
  FaXTwitter,
  FaTiktok,
} from "react-icons/fa6";

const FooterLinks = () => {
  const [date, setDate] = useState(null);

  useEffect(() => {
    setDate(new Date().getFullYear());
  }, []);

  const navigation = {
    services: [
      { name: "Web Design", href: "/web-design" },
      { name: "SEO", href: "/seo" },
      { name: "VIP Support", href: "/vip-support" },
      { name: "Paid Search", href: "/paid-search" },
      { name: "Social Media", href: "/social-media-marketing" },
      { name: "Email", href: "/email-marketing" },
    ],
    specialty: [
      { name: "BigCommerce Design", href: "/bigcommerce" },
      { name: "Shopify Design", href: "/shopify" },
      { name: "BigCommerce to Shopify", href: "/bigcommerce-to-shopify" },
      {
        name: "AI Customer Service Agent",
        href: "/addons/ai-customer-service-agent",
      },
      { name: "Custom 404 Pages", href: "/addons/custom-404-pages" },
    ],
    company: [
      { name: "About Us", href: "/about" },
      { name: "Learn", href: "/learn" },
      { name: "Our Partners", href: "/partners" },
      { name: "Tampa", href: "/tampa" },
      { name: "Careers", href: "/careers" },
      { name: "Contact Us", href: "/contact-us" },
    ],
    legal: [
      { name: "Privacy", href: "/privacy" },
      { name: "Terms", href: "/terms" },
    ],
    social: [
      {
        name: "Facebook",
        href: "http://www.facebook.com/venturawebdesign",
        icon: <FaFacebook />,
      },
      {
        name: "Instagram",
        href: "https://www.instagram.com/venturawebdesign/",
        icon: <FaInstagram />,
      },
      {
        name: "X",
        href: "https://x.com/venturaweblv",
        icon: <FaXTwitter />,
      },
      {
        name: "LinkedIn",
        href: "https://www.linkedin.com/company/ventura-web-design/",
        icon: <FaLinkedin/>
      },
      {
        name: "YouTube",
        href: "https://www.youtube.com/user/venturawebdesign",
        icon: <FaYoutube />,
      },
      {
        name: "TikTok",
        href: "https://www.tiktok.com/@venturawebdesign",
        icon: <FaTiktok />,
      },
    ],
  };
  return (
    <footer className="bg-white" aria-labelledby="footer-heading">
      <h2 id="footer-heading" className="sr-only">
        Footer
      </h2>
      <div className="wrapper mx-auto px-5 pb-10 pt-20">
        <div className="xl:grid xl:grid-cols-5 xl:gap-8">
          <div className="col-span-2 space-y-8">
            <Logo />
            <p className="text-sm leading-6 text-gray-600">
              Ventura Web Design & Marketing is a web design company and digital
              marketing agency that designs, builds, and markets professional
              ecommerce mobile-ready websites.
            </p>

            <div className="mt-6 space-y-2.5 text-gray-500">
              <div className="flex items-baseline gap-2.5">
                <FaLocationDot className="relative top-0.5 shrink-0 text-xs" />
                <div
                  className="text-sm leading-6"
                  style={{ marginTop: "-2px" }}
                >
                  1810 W Kennedy Blvd Ste 323
                  <br />
                  Tampa, FL 33606
                </div>
              </div>
              <div className="flex items-baseline gap-2.5">
                <FaPhone className="relative top-0.5 shrink-0 text-xs" />
                <a
                  href="tel:813-556-7990"
                  className="text-sm leading-6"
                  style={{ marginTop: "-2px" }}
                >
                  813-556-7990
                </a>
              </div>
            </div>
          </div>
          <div className="grid-cols mt-16 grid gap-8 xl:col-span-2 xl:mt-0">
            <div className="md:grid md:grid-cols-2 md:gap-8">
              <div>
                <h3 className="text-sm font-semibold leading-6 text-gray-900">
                  Services
                </h3>
                <ul className="mt-6 space-y-2.5">
                  {navigation.services.map((item) => (
                    <li key={item.name}>
                      <Link
                        prefetch={false}
                        href={item.href}
                        className="text-sm leading-6 text-gray-600 hover:text-gray-900"
                      >
                        {item.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="mt-10 md:mt-0">
                <h3 className="text-sm font-semibold leading-6 text-gray-900">
                  Quick Links
                </h3>
                <ul className="mt-6 space-y-2.5">
                  {navigation.specialty.map((item) => (
                    <li key={item.name}>
                      <Link
                        prefetch={false}
                        href={item.href}
                        className="text-sm leading-6 text-gray-600 hover:text-gray-900"
                      >
                        {item.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
          <div className="mt-10 md:mt-0">
            <h3 className="text-sm font-semibold leading-6 text-gray-900">
              Company
            </h3>
            <ul className="mt-6 space-y-2.5">
              {navigation.company.map((item) => (
                <li key={item.name}>
                  <Link
                    prefetch={false}
                    href={item.href}
                    className="text-sm leading-6 text-gray-600 hover:text-gray-900"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="mt-10 flex w-full flex-col-reverse items-center justify-between gap-5 border-t pt-10 lg:flex-row">
          <p className="text-xs leading-5 text-gray-500">
            &copy; {date} • Ventura Web Design & Marketing. All rights reserved.
          </p>
          <div className="flex space-x-6">
            {navigation.social.map((item) => (
              <a
                key={item.name}
                href={item.href}
                className="text-gray-500 hover:text-gray-600"
              >
                <span className="sr-only">{item.name}</span>
                <div className="text-xl">{item.icon}</div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterLinks;
